// src/store/slices/assetAssignLogSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import assetAssignLogApi from 'api/assetAssignLogApi';

export const fetchAssetAssignLogs = createAsyncThunk(
  'assetAssignLog/fetchAll',
  async ({ page = 1, pageSize = 20, search = '', asset_assign = '' }, { rejectWithValue }) => {
    try {
      const res = await assetAssignLogApi.getAll(page, pageSize, search, asset_assign);
      return res;
    } catch (e) {
      return rejectWithValue(e.response?.data?.detail || 'Failed to load asset assignment logs');
    }
  }
);

const assetAssignLogSlice = createSlice({
  name: 'assetAssignLog',
  initialState: {
    logs: [],
    pagination: { count: 0, page_size: 20 },
    isLoading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAssetAssignLogs.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchAssetAssignLogs.fulfilled, (state, action) => {
        state.isLoading = false;
        state.logs = action.payload.data || [];
        state.pagination = action.payload.pagination || { count: 0, page_size: 20 };
      })
      .addCase(fetchAssetAssignLogs.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export const { clearError } = assetAssignLogSlice.actions;
export default assetAssignLogSlice.reducer;